export default "__VITE_ASSET__337fff84__"